import { Injectable } from '@angular/core';
import { CovanceGridColumn, dateTimeRenderer, dateRenderer, dateTimeComparator } from '../../../covance-ag-grid';
import { EQueriesColumns } from '../../../e-queries/e-queries-columns';
import { comparators, UrlBuilder } from '../../../core';
import { ExternalUserEQuery } from '../../../e-queries/models/external-user-e-query';
import { EQuerySummary } from '../models/e-query-summary';

@Injectable()
export class AdminEQuerySummaryColumns {
    private readonly projectNumber: CovanceGridColumn = {
        headerName: 'Project',
        field: 'projectNumber',
                floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        width: 90,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };

    private readonly accessionNumber: CovanceGridColumn = {
        headerName: 'Accession',
        field: 'accessionNumber',
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        width: 120,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };

    private readonly siteName: CovanceGridColumn = {
        headerName: 'Site',
        field: 'siteDisplayName',
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        width: 70,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };

    private readonly status: CovanceGridColumn = {
        headerName: 'Status',
        field: 'eQueryStatus',
        width: 70,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };
    
     private readonly protocolName: CovanceGridColumn = {
        headerName: 'Protocol',
        field: 'protocolName',
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        width: 90,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };

    private readonly sponsorName: CovanceGridColumn = {
        headerName: 'Sponsor',
        field: 'sponsorName',
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        width: 90,
        comparator: (a, b) => comparators.mixedStringComparator(a, b)
    };

    private readonly visitCollectionDate: CovanceGridColumn = {
        headerName: 'Collected Date',
        field: 'visitCollectionDate',
        width: 70,
        comparator: dateTimeComparator,
        valueGetter: (params: {data: EQuerySummary}) => {
            if (!params.data) {
                return null;
            }
            return dateRenderer({ value: params.data.visitCollectionDate });
        }
    };

    private responseTime: CovanceGridColumn = {
        headerName: 'Response Date Time',
        field: 'responseTime',
        width: 100,
        comparator: dateTimeComparator,
        valueGetter: (params: { data: EQuerySummary }) => {
            if (!params.data) {
                return null;
            }
            return dateTimeRenderer({ value: params.data.responseDateTime });
        },
    };

    constructor(private readonly gridColumns: EQueriesColumns,
                private readonly eQueriesColumns: EQueriesColumns,
                private readonly urlBuilder: UrlBuilder) {
    }    

    public getEQueriesSummariesColumns(): CovanceGridColumn[] {
        return [
            this.eQueriesColumns.eQueryIdColumn<ExternalUserEQuery>(params =>
                this.urlBuilder
                .esa()
                .globalPopup()
                .coordinatorEQueryDetails(params.data.eQueryId)
                .url()),
            this.status,
            this.accessionNumber,
            this.sponsorName,
            this.protocolName,
            this.projectNumber,
            this.siteName, 
            this.visitCollectionDate,
            this.gridColumns.ageColumn(),
            this.gridColumns.responders(),
            this.responseTime
        ];
    }
}
